import React from 'react';
import { CoreProviders } from './CoreProviders';
import { DataProviders } from './DataProviders';
import { UIProviders } from './UIProviders';

export const AppProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <CoreProviders>
    <DataProviders>
      <UIProviders>
        {children}
      </UIProviders>
    </DataProviders>
  </CoreProviders>
);
